export const digitalKeyBoardPattern = '[0-9]*';
